import React, { useEffect, useState } from 'react';
import { Box, LinearProgress, Typography, Alert, Tooltip, Fade, Paper } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const COHERENCE_THRESHOLD = 0.7;
const NUANCE_THRESHOLD = 0.6;
const MIN_QUESTIONS_FOR_WARNING = 3; // Minimum number of questions before showing warnings

const MetricProgress = ({ value, label, description, threshold }) => {
  const isLow = value < threshold;
  const getColor = () => {
    if (value < threshold) return 'error';
    if (value < threshold + 0.1) return 'warning';
    return 'success';
  };
  
  const color = getColor();
  const colorMap = {
    error: '#EF4444',
    warning: '#F59E0B',
    success: '#10B981'
  };
  
  return (
    <Tooltip 
      title={description} 
      arrow 
      placement="left"
    >
      <Box sx={{ 
        width: '100%', 
        mb: 2,
        transition: 'all 0.3s ease',
        '&:hover': {
          transform: 'translateY(-2px)'
        }
      }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5, alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {color === 'success' ? (
              <CheckCircleOutlineIcon sx={{ fontSize: 16, mr: 0.5, color: colorMap[color] }} />
            ) : (
              <InfoOutlinedIcon sx={{ fontSize: 16, mr: 0.5, color: colorMap[color] }} />
            )}
            <Typography variant="body2" fontWeight={500} color={colorMap[color]}>
              {label}
            </Typography>
          </Box>
          <Typography variant="body2" fontWeight={600} color={colorMap[color]}>
            {Math.round(value * 100)}%
          </Typography>
        </Box>
        <LinearProgress 
          variant="determinate" 
          value={value * 100}
          sx={{ 
            height: 8, 
            borderRadius: 4,
            backgroundColor: 'rgba(0,0,0,0.05)',
            '& .MuiLinearProgress-bar': {
              backgroundColor: colorMap[color],
              borderRadius: 4
            }
          }}
        />
      </Box>
    </Tooltip>
  );
};

const MetricsDisplay = () => {
  return null;
};

export default MetricsDisplay;